import styled from 'styled-components';

export const StyledTabs = styled.div`
  display: flex;
  .tab {
    color: #000;
    font-size: 14px;
    line-height: 20px;
    border: none;
    outline: none;
    padding: 12px;
    border-bottom: 1px solid #dee2e6 !important;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    .count {
      min-width: 17px;
      height: 17px;
      border-radius: 50%;
      background: #228be6;
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      line-height: 17px;
    }
    &.active {
      border-bottom: 1px solid #228be6 !important;
    }
  }
`;
